"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mega Matcher ID management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2024.2.0
 * Contact: support@neurotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSubjectsQRCodeBySubjectIdModalities = exports.SubjectsApi = exports.SubjectsApiFactory = exports.SubjectsApiFp = exports.SubjectsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../../common");
// @ts-ignore
const base_1 = require("../../base");
/**
 * SubjectsApi - axios parameter creator
 * @export
 */
exports.SubjectsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Clear all DB or by prefix depending on the use case.
         * @param {string} [prefix] Subject prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDb: (prefix, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/user/subjects/clear-db`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create new subject and insert it to the database
         * @param {CreateSubjectRequest} createSubjectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubject: (createSubjectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createSubjectRequest' is not null or undefined
            common_1.assertParamExists('createSubject', 'createSubjectRequest', createSubjectRequest);
            const localVarPath = `/user/subjects/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSubjectRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subject information by UUID
         * @param {string} uuid UUID of subject\&#39;s operation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultimodalSubjectByOperationId: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getMultimodalSubjectByOperationId', 'uuid', uuid);
            const localVarPath = `/user/subjects/multimodal/operation/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subject information by UUID
         * @param {string} uuid UUID with which subject was created
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSubjectByOperationId: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getSubjectByOperationId', 'uuid', uuid);
            const localVarPath = `/user/subjects/operation/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Modalities to which the subject has already been enrolled
         * @param {string} subjectId Subject\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsEnrolledModalities: (subjectId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subjectId' is not null or undefined
            common_1.assertParamExists('getSubjectsEnrolledModalities', 'subjectId', subjectId);
            const localVarPath = `/user/subjects/modality/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            if (subjectId !== undefined) {
                localVarQueryParameter['subjectId'] = subjectId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subjects\' id list
         * @param {string} [prefix] Prefix to filter subject ids with
         * @param {string} [subjectId] Subject id to filter subject ids with
         * @param {number} [size] Size of subject list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsIdList: (prefix, subjectId, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/user/subjects/id-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }
            if (subjectId !== undefined) {
                localVarQueryParameter['subjectId'] = subjectId;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary QR code of the MegaMatcherId template
         * @param {string} subjectid QR code which to use to verify
         * @param {Array<GetSubjectsQRCodeBySubjectIdModalities>} [modalities] Subject\&#39;s modality
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsQRCodeBySubjectId: (subjectid, modalities, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subjectid' is not null or undefined
            common_1.assertParamExists('getSubjectsQRCodeBySubjectId', 'subjectid', subjectid);
            const localVarPath = `/user/subjects/qrcode/{subjectid}`
                .replace(`{${"subjectid"}}`, encodeURIComponent(String(subjectid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            if (modalities) {
                localVarQueryParameter['modalities'] = modalities;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetTemplateModalitiesRequest} getTemplateModalitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateModalities: (getTemplateModalitiesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getTemplateModalitiesRequest' is not null or undefined
            common_1.assertParamExists('getTemplateModalities', 'getTemplateModalitiesRequest', getTemplateModalitiesRequest);
            const localVarPath = `/user/subjects/qrcode/modalities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(getTemplateModalitiesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows to reextract the template to the current version for the best accuracy
         * @param {ReextractSubjectRequest} reextractSubjectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reextractSubject: (reextractSubjectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reextractSubjectRequest' is not null or undefined
            common_1.assertParamExists('reextractSubject', 'reextractSubjectRequest', reextractSubjectRequest);
            const localVarPath = `/user/subjects/reextract-subject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication user required
            // http basic authentication required
            common_1.setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(reextractSubjectRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SubjectsApi - functional programming interface
 * @export
 */
exports.SubjectsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SubjectsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Clear all DB or by prefix depending on the use case.
         * @param {string} [prefix] Subject prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDb(prefix, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clearDb(prefix, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create new subject and insert it to the database
         * @param {CreateSubjectRequest} createSubjectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubject(createSubjectRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSubject(createSubjectRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get subject information by UUID
         * @param {string} uuid UUID of subject\&#39;s operation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultimodalSubjectByOperationId(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMultimodalSubjectByOperationId(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get subject information by UUID
         * @param {string} uuid UUID with which subject was created
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSubjectByOperationId(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubjectByOperationId(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Modalities to which the subject has already been enrolled
         * @param {string} subjectId Subject\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsEnrolledModalities(subjectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubjectsEnrolledModalities(subjectId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get subjects\' id list
         * @param {string} [prefix] Prefix to filter subject ids with
         * @param {string} [subjectId] Subject id to filter subject ids with
         * @param {number} [size] Size of subject list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsIdList(prefix, subjectId, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubjectsIdList(prefix, subjectId, size, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary QR code of the MegaMatcherId template
         * @param {string} subjectid QR code which to use to verify
         * @param {Array<GetSubjectsQRCodeBySubjectIdModalities>} [modalities] Subject\&#39;s modality
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsQRCodeBySubjectId(subjectid, modalities, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubjectsQRCodeBySubjectId(subjectid, modalities, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GetTemplateModalitiesRequest} getTemplateModalitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateModalities(getTemplateModalitiesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTemplateModalities(getTemplateModalitiesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows to reextract the template to the current version for the best accuracy
         * @param {ReextractSubjectRequest} reextractSubjectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reextractSubject(reextractSubjectRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reextractSubject(reextractSubjectRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SubjectsApi - factory interface
 * @export
 */
exports.SubjectsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SubjectsApiFp(configuration);
    return {
        /**
         *
         * @summary Clear all DB or by prefix depending on the use case.
         * @param {SubjectsApiClearDbRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDb(requestParameters = {}, options) {
            return localVarFp.clearDb(requestParameters.prefix, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create new subject and insert it to the database
         * @param {SubjectsApiCreateSubjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubject(requestParameters, options) {
            return localVarFp.createSubject(requestParameters.createSubjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subject information by UUID
         * @param {SubjectsApiGetMultimodalSubjectByOperationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultimodalSubjectByOperationId(requestParameters, options) {
            return localVarFp.getMultimodalSubjectByOperationId(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subject information by UUID
         * @param {SubjectsApiGetSubjectByOperationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSubjectByOperationId(requestParameters, options) {
            return localVarFp.getSubjectByOperationId(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Modalities to which the subject has already been enrolled
         * @param {SubjectsApiGetSubjectsEnrolledModalitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsEnrolledModalities(requestParameters, options) {
            return localVarFp.getSubjectsEnrolledModalities(requestParameters.subjectId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subjects\' id list
         * @param {SubjectsApiGetSubjectsIdListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsIdList(requestParameters = {}, options) {
            return localVarFp.getSubjectsIdList(requestParameters.prefix, requestParameters.subjectId, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary QR code of the MegaMatcherId template
         * @param {SubjectsApiGetSubjectsQRCodeBySubjectIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectsQRCodeBySubjectId(requestParameters, options) {
            return localVarFp.getSubjectsQRCodeBySubjectId(requestParameters.subjectid, requestParameters.modalities, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubjectsApiGetTemplateModalitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateModalities(requestParameters, options) {
            return localVarFp.getTemplateModalities(requestParameters.getTemplateModalitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows to reextract the template to the current version for the best accuracy
         * @param {SubjectsApiReextractSubjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reextractSubject(requestParameters, options) {
            return localVarFp.reextractSubject(requestParameters.reextractSubjectRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SubjectsApi - object-oriented interface
 * @export
 * @class SubjectsApi
 * @extends {BaseAPI}
 */
class SubjectsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Clear all DB or by prefix depending on the use case.
     * @param {SubjectsApiClearDbRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    clearDb(requestParameters = {}, options) {
        return exports.SubjectsApiFp(this.configuration).clearDb(requestParameters.prefix, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create new subject and insert it to the database
     * @param {SubjectsApiCreateSubjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    createSubject(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).createSubject(requestParameters.createSubjectRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subject information by UUID
     * @param {SubjectsApiGetMultimodalSubjectByOperationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    getMultimodalSubjectByOperationId(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).getMultimodalSubjectByOperationId(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subject information by UUID
     * @param {SubjectsApiGetSubjectByOperationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    getSubjectByOperationId(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).getSubjectByOperationId(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Modalities to which the subject has already been enrolled
     * @param {SubjectsApiGetSubjectsEnrolledModalitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    getSubjectsEnrolledModalities(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).getSubjectsEnrolledModalities(requestParameters.subjectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subjects\' id list
     * @param {SubjectsApiGetSubjectsIdListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    getSubjectsIdList(requestParameters = {}, options) {
        return exports.SubjectsApiFp(this.configuration).getSubjectsIdList(requestParameters.prefix, requestParameters.subjectId, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary QR code of the MegaMatcherId template
     * @param {SubjectsApiGetSubjectsQRCodeBySubjectIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    getSubjectsQRCodeBySubjectId(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).getSubjectsQRCodeBySubjectId(requestParameters.subjectid, requestParameters.modalities, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SubjectsApiGetTemplateModalitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    getTemplateModalities(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).getTemplateModalities(requestParameters.getTemplateModalitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows to reextract the template to the current version for the best accuracy
     * @param {SubjectsApiReextractSubjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjectsApi
     */
    reextractSubject(requestParameters, options) {
        return exports.SubjectsApiFp(this.configuration).reextractSubject(requestParameters.reextractSubjectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SubjectsApi = SubjectsApi;
/**
 * @export
 */
exports.GetSubjectsQRCodeBySubjectIdModalities = {
    FaceModality: 'FACE_MODALITY',
    VoiceModality: 'VOICE_MODALITY',
    FingersLeftHandModality: 'FINGERS_LEFT_HAND_MODALITY',
    FingersRightHandModality: 'FINGERS_RIGHT_HAND_MODALITY',
    Unrecognized: 'UNRECOGNIZED'
};
